export const BERATER_KENNZEICHEN = {
  DEFAULT_NONE_SELECT_YES_NO: "1",
  DEFAULT_NO_SELECT_NONE: "2",
  DEFAULT_YES_SELECT_NONE: "3",
  DEFAULT_NO_SELECT_YES_NO: "4",
  DEFAULT_YES_SELECT_YES_NO: "5",
  DEFAULT_NONE_SELECT_NONE: "6",
  KEIN_BERATERKENNZEICHEN: "none"
}
